import React from 'react';

// Desktop ChangePassword — centred card.
export default function ChangePasswordDesktop({ vm }) {
  const { user, mustChangePassword, defaultPassword, pw, setPw, confirm, setConfirm, show, setShow, busy, err, submit, doLogout, back } = vm;
  return (
    <div className="center-screen">
      <div className="card" style={{ width: '100%', maxWidth: 400 }}>
        <div className="card-pad">
          <div style={{ fontSize: 22, fontWeight: 800, color: 'var(--brand)', textAlign: 'center' }}>
            {mustChangePassword ? 'Set your password' : 'Change password'}
          </div>
          <div className="muted" style={{ margin: '6px 0 16px', fontSize: 13, textAlign: 'center' }}>
            {mustChangePassword
              ? <>Your password is still the default <strong>{defaultPassword}</strong>. Choose your own password to continue — it is required once.</>
              : <>Signed in as <strong>{user?.MobileNumber}</strong></>}
          </div>
          <form onSubmit={submit}>
            <label className="field">New password
              <input type={show ? 'text' : 'password'} value={pw} autoFocus autoComplete="new-password"
                placeholder="4–20 characters" onChange={(e) => setPw(e.target.value)} />
            </label>
            <label className="field">Confirm new password
              <input type={show ? 'text' : 'password'} value={confirm} autoComplete="new-password"
                onChange={(e) => setConfirm(e.target.value)} />
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, marginBottom: 12 }}>
              <input type="checkbox" checked={show} style={{ width: 'auto' }} onChange={(e) => setShow(e.target.checked)} />
              Show password
            </label>
            {err && <div style={{ color: 'var(--danger)', fontSize: 13, marginBottom: 10 }}>{err}</div>}
            <button className="btn primary" style={{ width: '100%' }} disabled={busy}>
              {busy ? 'Saving…' : 'Save password'}
            </button>
          </form>
          <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            {!mustChangePassword && <button className="btn light" style={{ flex: 1 }} onClick={back}>Back</button>}
            <button className="btn light" style={{ flex: 1 }} onClick={doLogout}>Logout</button>
          </div>
        </div>
      </div>
    </div>
  );
}
